import React from 'react';
import {
  Box,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  InputAdornment,
} from '@mui/material';
import { Search, FilterListOff } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const COUNTRY_OPTIONS = ['UA', 'KZ', 'PL'];

const VoicePackagesFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const { t } = useTranslation();

  const hasActiveFilters = filters.country || filters.search;

  const inputSx = {
    '& .MuiOutlinedInput-root': {
      borderRadius: 1,
      '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#00C853' },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#00C853' },
    },
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: 'none',
        p: 2,
        mb: 2.5,
        bgcolor: 'white',
        boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
      }}
    >
      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        {/* Country Select */}
        <FormControl size="small" sx={{ minWidth: 160, ...inputSx }}>
          <InputLabel>{t('voicePackages.country', 'Country')}</InputLabel>
          <Select
            value={filters.country}
            onChange={(e) => onFilterChange('country', e.target.value)}
            label={t('voicePackages.country', 'Country')}
          >
            <MenuItem value="">
              <em>{t('voicePackages.allCountries', 'All')}</em>
            </MenuItem>
            {COUNTRY_OPTIONS.map((c) => (
              <MenuItem key={c} value={c}>
                {c}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {/* Search */}
        <TextField
          size="small"
          placeholder={t('voicePackages.searchPlaceholder', 'Search name...')}
          value={filters.search}
          onChange={(e) => onFilterChange('search', e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search sx={{ color: 'text.secondary', fontSize: 20 }} />
              </InputAdornment>
            ),
          }}
          sx={{
            minWidth: 200,
            ...inputSx,
          }}
        />

        {/* Clear Filters */}
        {hasActiveFilters && (
          <Button
            size="small"
            startIcon={<FilterListOff />}
            onClick={onClearFilters}
            sx={{
              textTransform: 'none',
              color: 'text.secondary',
              '&:hover': { color: '#00C853' },
            }}
          >
            {t('voicePackages.clearFilters', 'Clear Filters')}
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default VoicePackagesFilters;
